import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './style.css';
import APIClient from '../../client';
import S from 'string';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import './searches.css';

const PAGE_LIMIT = 10;

class App extends Component {
  constructor(params) {
    super(params);
    this.state = {
      
      group:        params.group,
      item:         params.record,
      user:         params.user,
      locality:     params.locality,
      search:       params.record.microchip,
      offset:       0,
      hasMore:      true,
      section:      'loading'

    };
    this.handleUserChange = params.handleUserChange;
  }
  componentDidMount = async () => {

    document.title = 'Searches for ' + this.state.item.uid
    await this.fetchSearchItems();
    this.setState({
      section: 'loaded'
    })

  }
  fetchSearchItems = async () => {

    // get the token
    let token = APIClient.getToken();

    // get the items
    let items = [];

    // set the items
    let query = {
      token,
      q:      this.state.item.uid,
      limit:  PAGE_LIMIT,
    };
    
    // handle errors
    try {
      let result = await APIClient.call({

        path:   '/groups/' + this.state.group.slug + '/responses',
        query:  query
  
      });
      items = result.data || [];
    } catch(err) {
      this.setState({
        errorMessage: 'Problem getting the new items'
      })
      if(items.length === 0) {
        this.setState({
          section: 'error'
        })
        return;
      }
    }

    // set the item
    this.setState({
      items,
      hasMore: items.length === PAGE_LIMIT
    })

  }
  handleSearchQueryChange = () => {
    if(this.timer) clearTimeout(this.timer);
    this.setState({
      search: this.inputSearchQuery.current.value
    }, () => {
      this.timer = setTimeout(this.handleResetSearch, 100);
    });
  }
  handleResetSearch = () => {
    this.setState({
      
      limit:    PAGE_LIMIT,
      offset:   0,
      hasMore:  true

    }, this.fetchSearchItems);
  }
  handleNext = async () => {
    let offset = this.state.offset + PAGE_LIMIT;

    // get the token
    let token = APIClient.getToken();

    // pulled items
    let pulleditems = [];

    // set the items
    let query = {
      token,
      offset: offset,
      limit: PAGE_LIMIT,
    };

    // add params
    if(S(this.state.search).isEmpty() === false) {
      query.q = this.state.search;
    }

    // handle errors
    try {
      let result = await APIClient.call({

        path:   '/groups/' + this.state.item.slug + '/responses',
        query:  query
  
      });
      pulleditems = result.data || [];
    } catch(err) {
      this.setState({
        errorMessage: 'Problem getting the new items'
      })
    }

    let items = (this.state.items || []).concat(pulleditems || []);

    // set the item
    this.setState({
      items:    items,
      offset:   offset,
      hasMore:  pulleditems.length === PAGE_LIMIT
    })
  }
  renderItems = () => {
    if(this.state.items.length > 0) {

      return (<div className="grouprecord-searches-listing-items">
        {
          this.state.items.map((item) => {
            return (<div key={item.uid} className="grouprecord-searches-listing-item">
              <Link className="grouprecord-searches-listing-item-inner" key={item.uid} to={'/groups/' + this.state.group.slug + '/searches/' + item.uid}>
                <p>{moment(item.created).format('LLL')}</p>
                <div className="clearfix"></div>
                <div className="clearfix"></div>
              </Link>
            </div>);
          })
        }
        <div className="clearfix"></div>
      </div>);

    } else {

      return (<div className="grouprecord-items-blank">
        <span className="fas fa-search-minus"></span>
        <p>No searches for this record has taken place</p>
        <div className="clearfix"></div>
      </div>);

    }
  }
  render() {
    if(this.state.section === 'loading') {
      return (<div className="grouprecord-items-blank">
        <span className="fas fa-spinner"></span>
        <p>Loading...</p>
        <div className="clearfix"></div>
      </div>);
    }
    if(this.state.section === 'error') {
      return (<div className="grouprecord-items-blank">
        <span className="fas fa-exclamation-triangle"></span>
        <p>Unable to pull searches, try again in a few</p>
        <div className="clearfix"></div>
      </div>);
    }
    return (<div>

      <InfiniteScroll 
        dataLength={this.state.items.length} //This is important field to render the next data
        next={this.handleNext}
        hasMore={this.state.hasMore} 
        style={{
          overflow: 'visible'
        }}
        loader={<h4 style={{textAlign: 'center', marginTop: 25}}>Loading more searches...</h4>}
        endMessage={
            this.state.items.length > PAGE_LIMIT
          ?
            <p style={{textAlign: 'center', marginTop: 25}}>
              <b>No more searces found :|</b>
            </p>
          : 
            null
        }
        // below props only if you need pull down functionality
        refreshFunction={this.handleResetSearch} >
        
        {this.renderItems()}
        <div className="clearfix"></div>

      </InfiniteScroll>
    </div>);
  }
}

export default App;
